// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiSet {
    color: var(--primary-color);
}

.multiSeparatorMenu {
    padding: 10px;
}

    .multiSeparatorMenu .separatorBox {
        width: 35px;
        margin-right: 8px;
    }

    .multiSeparatorMenu .separatorLabel {
        font-size: 14px;
        align-self: center;
    }
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/advancedfilter/advancedfilter.component.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;IAEI;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB","sourcesContent":[".multiSet {\n    color: var(--primary-color);\n}\n\n.multiSeparatorMenu {\n    padding: 10px;\n}\n\n    .multiSeparatorMenu .separatorBox {\n        width: 35px;\n        margin-right: 8px;\n    }\n\n    .multiSeparatorMenu .separatorLabel {\n        font-size: 14px;\n        align-self: center;\n    }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
